var app = angular.module('AngularAdmin');

app.filter('formatFloat', require('./formatFloat.js'));
app.filter('formatTime', require('./formatTime.js'));
app.filter('wrap', require('./wrap.js'));
app.filter('percentage', require('./percentage.js'));